import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "../components/animations/ScrollAnimation";

const Footer = () => {
  return (
    <div className="pb-10  bg-background">
      <div className="max-w-[1500px] mx-auto">
        {/* footer */}

        <div className="flex  flex-col space-y-6  pt-10  text-white pl-10 w-[270px] self-end lg:flex-row lg:justify-between lg:w-full lg:px-10 lg:space-y-0 ">
          <ScrollAnimation direction="left" delay={0.5}>
            <p className="text-base font-medium">
              (c) Novwell 2022 - Design by notre super team 🚀
            </p>
          </ScrollAnimation>
          <div className="flex flex-col space-y-1 text-corps lg:flex-row lg:space-x-3 lg:space-y-0 lg:text-base">
            <ScrollAnimation direction="right" delay={0.5}>
              <Link to="/politique-de-confidentialite">
                Politique de cookies, Mentions légales et Politique de
                confidentialité
              </Link>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
